__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-28-1777377026-stable-dev/";